import React, {useEffect, useState} from 'react';
import {Dropdown} from 'react-bootstrap';
import "./Header.css"
import {UserService} from "../../services/UserService";
import {WebCache} from "../../services/WebCache";
import {useTranslation} from "react-i18next";
import Dictaphone from "../Dictaphone";
import {AxiosResponse} from 'axios';
//import {ServiceorkerRegister} from "../../services/ServiceWorkerRegister";
import {
    ReactComponent as IconNotificationsSVG
} from "../../../node_modules/itd-common/assets/icons/Ico_notificaciones.svg";
import {
    ReactComponent as IconMapNavigationEarthSVG
} from "../../../node_modules/itd-common/assets/icons/icono_mapnavigationearth.svg";
import {ReactComponent as IconUserSVG} from "../../../node_modules/itd-common/assets/icons/icono_usuario.svg";
import {ReactComponent as IconCompanySVG} from "../../../node_modules/itd-common/assets/icons/house-5.svg";
import {useLayout} from './LayoutContext';
import Swal from "sweetalert2";
import MultiCompanySelector from "../MultiCompanySelector";
import {useMessages} from "../MessagesContext";
import { UtilService } from '../../services/UtilService';

// forwardRef again here!
// Dropdown needs access to the DOM of the Menu to measure it
const UserMenu = React.forwardRef((props: any, ref) => {
    const [value, setValue] = useState('');

    return (
        <div
            style={props.style}
            className={props.className}
            aria-labelledby={props.labeledBy}
        >
            {props.children}
        </div>
    );
    },
);

interface ITaskDTO {
    longTasks: Array<ITask>,
    pendingCount: number,
    taskNameMailNotification: string,
}

interface ITask {
    id: string,
    endDate: string,
    name: string,
    error: string,
    progress: number,
    result: string,
    startDate: string,
    systemId: string,
    type: string,
    downloaded: boolean,
    cancelledByUser: boolean
}

interface IState {
    callUserProfile: boolean,
    Task: Array<ITask>,
    LastTasks: string[],
    ActuallyTasks: string[],
    notificationActived: boolean,
    GetPendingTaskAttemps: number,
    clientName:string,
    currentSystemIdSelected: string 
}

//constantes para identificar click en scroll notificaciones
const DROPDOWN_ELEMENT_ID= "dropdown-elemnt";
const DROPDOWN_SCROLL = "scrollable-menu";


let Header: React.FC = () => {
    const { showMenuButton, toggleMenu } = useLayout();
    let [state, setState] = useState<IState>({
        callUserProfile: true,
        Task: [],
        LastTasks: [],
        ActuallyTasks: [],
        notificationActived: false,
        GetPendingTaskAttemps: 0,
        clientName:"",
        currentSystemIdSelected: ""
    });
    let [disableCancelButton, setDisableCancelButton] = useState<string>("");
    let [showNotifications, setShowNotifications] = useState<boolean>(false);
    const  messages = useMessages()

    let [notifications, setNotifications] = useState<{ notificationsLoader: boolean, showNotifications: boolean }>({notificationsLoader: false,showNotifications: false

    })

    var GetPendingTaskT: any | null = null;

    useEffect(() => {
        setState({ ...state, callUserProfile: false,
            clientName: state.clientName?.length === 0 && WebCache.getMultiCompanyFiscalDocumentList().length > 0 ? WebCache.getMultiCompanyFiscalDocumentList()[0].clientName: "",
            currentSystemIdSelected: state.currentSystemIdSelected?.length === 0 && WebCache.getMultiCompanyFiscalDocumentList().length > 0 ? WebCache.getMultiCompanyFiscalDocumentList()[0].systemId: "" });
        
        if (!state.callUserProfile) {
            if (!WebCache.isPosnetAppUser()) {
                UserService.getUserProfile();
            }
            //ServiceorkerRegister.registerWorkers();
            GetPendingTask(true)
            if (GetPendingTaskT === null) {
                GetPendingTaskT = setInterval(GetPendingTask, 10000);
            }
        }
    }, [state.callUserProfile]);

    let GetPendingTaskAttemps = 0;
    let GetPendingTask = async (firstTime: boolean = false) => {

        let LastRunTime= localStorage.getItem("_lastAllTaskRun");
        if(LastRunTime==null)
        LastRunTime=(new Date().getTime()-100000)+"";
        var secondsLastRun = (new Date().getTime()-Number(LastRunTime)) / 1000;

        if (WebCache.isTaskRuning()&&WebCache.getCurrentUser()!=null&&secondsLastRun>30) {
            await GetPendingTaskForce();
        }
        {
            setNotifications(prevState => ({ ...prevState, notificationsLoader: false }));
        }
    };

    let GetPendingTaskForce = async () => {
        localStorage.setItem("_lastAllTaskRun",new Date().getTime()+"");
        WebCache.initSettlements();
        UserService.getAllTasks(30).then((response: AxiosResponse<ITaskDTO>) => {
            if (response.data.longTasks.length > 0) {
                let tasks = response.data.longTasks;
                for (const key in tasks)
                    if (!tasks[key].downloaded && tasks[key].progress == 100 && !tasks[key].cancelledByUser
                        && tasks[key].name.indexOf("UPLOAD_SETTLEMENT_FILE") <0
                    ) {
                        downloadExcel(tasks[key]);
                    }
            }
            if (response.data.taskNameMailNotification !== "") {
                Swal.fire({
                    html: `<span class="wrapText">${t("TaskNameMailNotification",  {name : response.data.taskNameMailNotification}) }</span>`,
                    confirmButtonColor:'#f60'
                });
            }
            setState({ ...state, Task: response.data.longTasks, clientName:WebCache.getMultiCompanyFiscalDocumentList().length>0?WebCache.getMultiCompanyFiscalDocumentList()[0].clientName:"" })
            GetPendingTaskAttemps++
            let findProgress = response.data.longTasks.find(tas => tas.progress < 100)
            if (findProgress == undefined) {
                setNotifications(prevState => ({ ...prevState, notificationsLoader: false }));
            }
            if (GetPendingTaskAttemps > 7 && findProgress == undefined) {
                setNotifications(prevState => ({ ...prevState, notificationsLoader: false }));
                GetPendingTaskAttemps = 0
            }
        }).catch(() => { setNotifications(prevState => ({ ...prevState,notificationsLoader: false }));  })
    };

    const renderDownloadMerchantApp = () => {
        const isIOS = /iPhone/.test(navigator.userAgent);
        const isAndroid = /Android/.test(navigator.userAgent);
    
    if (!isIOS) {
            return (
                <>
                <Dictaphone></Dictaphone>
                <a className="icon-svg-container text-center cursor-pointer" data-bs-toggle="modal">
                    <IconMapNavigationEarthSVG className="icon-svg icon-svg--size"></IconMapNavigationEarthSVG>
                    <span className="fs-16 d-none d-xl-block text-gray header-text" hidden={showMenuButton}>{t("languageSpanish")}</span>
                </a></>
            );
        } else {
            return (
                ""
            );
        }
    };

    let showNotification = () =>{
        setNotifications({ ...notifications, notificationsLoader: false, showNotifications: !notifications.showNotifications })
        setShowNotifications(!showNotifications);
    }

    let cancelDownload = async (task:ITask) => {
        if(disableCancelButton === "")
            setDisableCancelButton(task.id);
            let result= await UserService.CancelTask(task.id); //TODO manejor de errores y evitar multiples llamadas
            setDisableCancelButton("");
    }

    let downloadExcel = (task:ITask) => {
        UserService.GetExcelPdf(task.id, task.name).then((response: AxiosResponse<any>) => {

            if(task.error!=null){
                Swal.fire({
                    title: "Error",
                    html: task.error,
                    confirmButtonColor: '#f60',
                    timer: 6000,
                    timerProgressBar: true,
                    icon:"warning"
                });
                return;
            }

            //const outputFilename = `TerminalsReport${Date.now()}.xlsx`;
            // @ts-ignore
            let outputFilename = response.headers['content-disposition']
                .split(';')
                .find((n: any) => n.includes('filename='))
                .replace('filename=', '')
                .trim();
            const url = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', outputFilename);
            link.click();
        }).catch(error => {
            console.log('error:', error);
        });
    }

    useEffect(() => {
        const closeMenuOnClick = (event: MouseEvent) => {
            const clickedElement = event.target as HTMLElement;
            if (
                showNotifications &&
                !clickedElement.closest(`.${DROPDOWN_ELEMENT_ID}`) &&
                !clickedElement.closest(`.${DROPDOWN_SCROLL}`)
            ) {
                setNotifications({ ...notifications, notificationsLoader: false, showNotifications: false });
                setShowNotifications(false);
            }
        };
        document.addEventListener('mousedown', closeMenuOnClick);
        return () => {
            document.removeEventListener('mousedown', closeMenuOnClick);
        };
    }, [showNotifications, notifications]);

    const { t } = useTranslation();
    return (
        <React.Fragment>
            <div className="app-header header"  >
                <a className="contextMenuButton cursor-pointer" onClick={() => toggleMenu()}>
                    <i className="fa-solid fa-bars"></i>
                </a>
                <div className="main-container container-fluid">
                    <div className="d-flex">
                        <a className="menuLogo cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="32" viewBox="0 0 64 32"
                                fill="none" className="injected-svg"
                                data-src="data:image/svg+xml;base64,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"
                                >
                                <path d="M64 27.5977H59.9149V31.6611H64V27.5977Z" fill="#FF6600"></path>
                                <path
                                    d="M56.5106 9.56592L54.0425 27.6823L51.6596 9.56592H47.8298L51.3191 31.6612H56.7659L60.2553 9.56592H56.5106Z"
                                    fill="#FF6600"></path>
                                <path
                                    d="M5.78723 4.99471C5.78723 4.31746 5.95745 3.80952 6.21277 3.4709C6.55319 3.13228 7.06383 2.96296 7.65957 2.96296H8.34043V0H7.06383C5.44681 0 3.82979 0.338624 3.06383 1.01587C2.29787 1.69312 2.12766 2.79365 2.12766 4.40212V9.48148H0V12.4444H2.12766V31.6614H5.78723V12.4444H8.42553V9.48148H5.78723V4.99471Z"
                                    fill="#FF6600"></path>
                                <path d="M13.2766 9.56592H9.53192V31.7458H13.2766V9.56592Z" fill="#FF6600"></path>
                                <path
                                    d="M32.3404 9.31201C28.4255 9.31201 26.6383 11.0051 26.6383 15.0686V26.2432C26.6383 29.9681 28.9362 31.9152 32.3404 31.9152C35.7447 31.9152 38.0426 30.3067 38.0426 26.2432V24.4655H34.4681V26.5819C34.4681 28.1057 33.8723 29.1215 32.4255 29.1215C30.8936 29.1215 30.383 28.1057 30.383 26.5819V21.8411H38.1277V14.984C38.0426 10.9205 36.0851 9.31201 32.3404 9.31201ZM34.4681 18.8781H30.2979V14.3067C30.2979 13.0369 30.6383 11.767 32.3404 11.767C34.0426 11.767 34.383 13.0369 34.383 14.3067V18.8781H34.4681Z"
                                    fill="#FF6600"></path>
                                <path
                                    d="M21.617 19.0476C18.8085 16.5926 18.5532 16.254 18.5532 14.4762C18.5532 12.9524 18.7234 12.0212 20.0851 12.0212C21.4468 12.0212 21.617 12.9524 21.617 14.4762V16.508H25.1915V13.2064C25.1915 10.582 23.1489 9.22754 20 9.22754C16.8511 9.22754 14.8085 10.2434 14.8085 14.4762C14.8085 15.1535 14.8085 15.1535 14.8085 14.8995C14.8085 16.254 14.8085 18.2857 18.1277 21.0794L19.0638 21.8413C21.4468 23.873 21.7021 24.127 21.7021 26.4974C21.7021 28.0212 21.617 29.1217 20.0851 29.1217C18.5532 29.1217 18.383 28.0212 18.383 27.2593V24.5503H14.6383V27.5133C14.6383 31.1535 17.0213 32 20.0851 32C23.1489 32 25.5319 31.0688 25.5319 26.4974V26.0741C25.4468 22.8572 24.8511 21.926 21.617 19.0476Z"
                                    fill="#FF6600"></path>
                                <path
                                    d="M43.0638 11.767V9.56598H39.6595V31.7459H43.3191V16.2538C43.3191 15.0686 43.7447 14.3067 44.4255 13.7988C45.1064 13.3755 45.8723 13.2062 46.8936 13.2062V9.31201C44.851 9.31201 44.0851 9.65064 43.0638 11.767Z"
                                    fill="#FF6600"></path>
                            </svg>
                        </a>
                        {/* Notificaciones */}
                        <div className="d-flex order-lg-2 ms-auto icons-svg-container" >
                            <Dropdown show={showNotifications} drop={"down"} autoClose="outside">                                
                                <Dropdown.Toggle variant="link" bsPrefix="p-0">
                                    <a  
                                        onClick={showNotification}  
                                        hidden={UtilService.isMobilePlatform() && state.Task.length === 0}
                                        className="icon-svg-container theme-layout nav-link-bg cursor-pointer"
                                    >
                                        <IconNotificationsSVG
                                            className="icon-svg icon-svg--size"></IconNotificationsSVG>
                                        <span className="fs-16 d-none d-xl-block text-gray header-text"
                                            hidden={showMenuButton}>{t("notifications")}</span>
                                        {
                                            // WebCache.isTaskRuning() ?
                                            //     <span className="pulse"></span> : <></>
                                        }
                                    </a>
                                </Dropdown.Toggle>
                                <Dropdown.Menu as={UserMenu}  className="dropdown-menu-left scrollable-menu" style={{"left": "-300px", "right": "0px"}}>
                                    {
                                        (state.Task != null && state.Task.length > 0) ? state.Task.map((task: ITask, taskIndex) => {
                                            return (
                                                <div style={{color: 'black'}} className={`${DROPDOWN_ELEMENT_ID} dropdown-item`}
                                                    key={"a" + taskIndex}>
                                                    <small className={DROPDOWN_ELEMENT_ID} key={"p" + taskIndex}>{t(task.type)}</small>
                                                    {task.cancelledByUser !== true && task.progress === 100 ?
                                                            <div className={`${DROPDOWN_ELEMENT_ID} progress progress-md mb-3`}>
                                                                <div className={`${DROPDOWN_ELEMENT_ID} progress-bar bg-green`}
                                                                    style={{width: task.progress + "%"}}>100%
                                                                </div>
                                                            </div>
                                                        : 
                                                        <div key={"div1" + taskIndex}
                                                            className={`${DROPDOWN_ELEMENT_ID} progress progress-md mb-3`}>
                                                            <div key={"div2" + taskIndex}
                                                                className={`${DROPDOWN_ELEMENT_ID} progress-bar progress-bar-striped progress-bar-animated bg-green-1`}
                                                                style={{width: task.progress + "%"}}>
                                                                    <span className={`${DROPDOWN_ELEMENT_ID} d-flex justify-content-center`}>{task.progress > 10 && task.progress + "%"}</span>
                                                            </div>
                                                        </div>
                                                    }
                                                    <small className={`${DROPDOWN_ELEMENT_ID} taskName`}>{task.name + (task.error != null ? ("(" + task.error + ")") : "")} </small>
                                                    <br/>
                                                    <small className={`${DROPDOWN_ELEMENT_ID} taskDate`}>{new Date(task.startDate).toLocaleString('es-ES')}</small>
                                                    <br/>
                                                    <small
                                                        className={`${DROPDOWN_ELEMENT_ID} pe-3`}
                                                        hidden={task.name.indexOf("UPLOAD_SETTLEMENT_FILE") >= 0 || task.error != null || task.cancelledByUser === true || task.progress !== 100}
                                                        onClick={(event) => {
                                                            event.preventDefault(); 
                                                            event.stopPropagation();
                                                            downloadExcel(task);
                                                        }}
                                                    >
                                                        <a className="cursor-pointer">{t("RepeatAction")}</a>
                                                    </small>
                                                    <small
                                                        className={DROPDOWN_ELEMENT_ID}
                                                        hidden={task.cancelledByUser === true || task.progress === 100}
                                                        onClick={() => cancelDownload(task)}>
                                                        <a className={DROPDOWN_ELEMENT_ID}>{t("cancelAction")}</a>
                                                    </small>
                                                    <small
                                                        className={DROPDOWN_ELEMENT_ID}
                                                        hidden={task.cancelledByUser !== true}
                                                        ><div className={DROPDOWN_ELEMENT_ID}>{t("taskCancelled")}</div>
                                                    </small>
                                                </div>
                                            )
                                        }) : <></>
                                    }
                                </Dropdown.Menu>
                            </Dropdown>
                            {/* <a className="icon-svg-container theme-layout nav-link-bg " onClick={() => toggleHelp()}>
                                <IconHelpSVG className="icon-svg icon-svg--size" ></IconHelpSVG>
                                <span className="fs-16 d-none d-xl-block text-gray header-text">{t("help")}</span>
                            </a> */}
                            {/* Microfono + Idioma */}
                            {UtilService.isMobilePlatform()? "" : renderDownloadMerchantApp()}
                            {/* MultiClientes */}
                            <Dropdown hidden={state.clientName==""||state.clientName==null}>
                                <Dropdown.Toggle variant="link" bsPrefix='p-0' id="dropdown-autoclose-true">
                                    <div className="icon-svg-container toggleClient">
                                        <IconCompanySVG className="icon-svg icon-svg--size icon-svg-user"></IconCompanySVG>
                                        <span className="fs-16 d-none d-xl-block text-gray header-text">{state.clientName}</span>
                                    </div>0 
                                </Dropdown.Toggle> 
                                <Dropdown.Menu rootCloseEvent='mousedown' as={UserMenu} 
                                className="multiCompanyContainer">                                    
                                    <MultiCompanySelector  
                                        currentSystemIdProp = {state.currentSystemIdSelected} 
                                        onCompanyChange = {(currentSystemId)=>{
                                        setState({...state,
                                            clientName: WebCache.getMultiCompanyFiscalDocumentList().filter(x => x.systemId == currentSystemId)[0].clientName,                                            
                                            currentSystemIdSelected: WebCache.getMultiCompanyFiscalDocumentList().filter(x => x.systemId == currentSystemId)[0].systemId})         
                                        }                                       
                                    }></MultiCompanySelector>
                                </Dropdown.Menu>
                            </Dropdown>
                            {/* Logout */}
                            <Dropdown>
                                <Dropdown.Toggle variant="link" bsPrefix="p-0">
                                    <div className="icon-svg-container">
                                        <IconUserSVG className="icon-svg icon-svg--size icon-svg-user"></IconUserSVG>
                                        <span className="fs-16 d-none d-xl-block text-gray header-text"
                                            hidden={showMenuButton}>{t("greetingsCurrentUser", {userName: WebCache.getCurrentUser()?.name})}</span>
                                    </div>
                                </Dropdown.Toggle>
                                <Dropdown.Menu as={UserMenu} className="dropdown-menu-left responsive-dropdown">
                                    <div className="drop-heading">
                                        <div className="text-center">
                                            <h5 className="text-dark mb-0 fs-14 fw-semibold">{WebCache.getCurrentUser()?.name}</h5>
                                            <small className="text-muted">{WebCache.getCurrentUser()?.email}</small>
                                        </div>
                                    </div>
                                    <div className="dropdown-divider m-0"></div>
                                    {/*<a className="dropdown-item" href="profile.html">
                                    <i className="dropdown-icon fe fe-user"></i> Perfil
                                </a>
                                <a className="dropdown-item" href="email-inbox.html">
                                    <i className="dropdown-icon fe fe-mail"></i> Mensajes
                                    <span className="badge bg-danger rounded-pill float-end">5</span>
                                </a>
                                <a className="dropdown-item" href="lockscreen.html">
                                    <i className="dropdown-icon fe fe-lock"></i> bloquear pantalla
                                </a>*/}
                                    <a className="dropdown-item cursor-pointer"
                                    onClick={UserService.logout}>
                                        <i className="dropdown-icon fe fe-alert-circle"></i> {t("logOut")}
                                    </a>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
export default Header;